import { Component, OnInit } from '@angular/core';
import { ReportOption } from 'src/app/invoice/models/ReportOption';
import { ToastrService } from 'ngx-toastr';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { environment } from 'src/environments/environment';
import { ProcessorReportsService, ProcessorReport } from 'src/app/services/processor-reports.service';
import { tap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProcessorReportDialogComponent } from '../processor-report-dialogs/processor-report-dialog/processor-report-dialog.component';
import { VendorSearchBreakdownDialogComponent } from '../processor-report-dialogs/vendor-search-breakdown-dialog/vendor-search-breakdown-dialog.component';
import { ApiCredentialsReportDialogComponent } from '../processor-report-dialogs/api-credentials-report-dialog/api-credentials-report-dialog.component';
import { ClientTatBreakdownDialogComponent } from '../processor-report-dialogs/client-tat-breakdown-dialog/client-tat-breakdown-dialog.component';
import { ProcessorAuditDialogComponent } from '../processor-report-dialogs/processor-audit-dialog/processor-audit-dialog.component';
import { DivInviteReportDialogComponent } from '../processor-report-dialogs/div-invite-report-dialog/div-invite-report-dialog.component';
import { DivDocumentsReportDialogComponent } from '../processor-report-dialogs/div-documents-report-dialog/div-documents-report-dialog.component';

@Component({
  selector: 'app-processor-report-download',
  templateUrl: './processor-report-download.component.html',
  styleUrls: ['./processor-report-download.component.less']
})
export class ProcessorReportDownloadComponent implements OnInit {
  
  constructor(public toast: ToastrService, public fileDownload: FileDownloadService,public rpts : ProcessorReportsService,private readonly modalService: NgbModal) { }

  loading: boolean = false;

  


  ngOnInit(): void {
    this.loading = true;
    this.rpts.getReportsList().pipe(tap((rpts: ProcessorReport[])=>{
      this.reportOptions = rpts;
      console.log('reports fetched', this.reportOptions);
      this.loading = false;
    })).subscribe();
  }

  public reportOptions: ProcessorReport[];
  public reportOptionsWithDialog: ProcessorReport[] = [
    { dialogName : 'VendorSearchBreakdownDialogComponent', id : 0,hasParams: true, reportPrettyName : '', reportDownloadName : '', reportSproc : '', params: undefined, dialog : VendorSearchBreakdownDialogComponent},
    { dialogName : 'ClientTatBreakdownDialogComponent', id : 2,hasParams: true, reportPrettyName : '', reportDownloadName : '', reportSproc : '', params: undefined, dialog : ClientTatBreakdownDialogComponent},
    { dialogName : 'APICredentialsForLocationsByClient', id: 1, hasParams: true, reportPrettyName: 'API Credentials Report', reportSproc: 'sp_ClientLocation_VendorCredsByClientId',  
      reportDownloadName: 'APICredentialsForLocation.csv', params: undefined, dialog: ApiCredentialsReportDialogComponent },
    { dialogName: 'ProcessorAuditDialogComponent', id:14, hasParams: true, params: undefined, reportDownloadName: '', reportPrettyName: 'Processing Audit', 
      reportSproc: 'sp_rpts_ProcAuditReport', dialog: ProcessorAuditDialogComponent },
    { dialogName: 'DivInviteReportDialogComponent', id:18, hasParams: true, params: undefined, reportDownloadName: '', reportPrettyName: 'DIV Invite Report', 
      reportSproc: 'sp_rpts_ProcAuditReport', dialog: DivInviteReportDialogComponent },
    { dialogName: 'DivDocumentsReportDialogComponent', id:19, hasParams: true, params: undefined, reportDownloadName: '', reportPrettyName: 'DIV Documents Report', 
      reportSproc: 'sp_rpts_ProcAuditReport', dialog: DivDocumentsReportDialogComponent }
  ];


  downloadRptData(rpt : ProcessorReport): void {
    if(rpt.hasParams){
      // go lookup the matching reportOptionsWithDialog instance and use that to launch the dialog.
      var match = this.reportOptionsWithDialog.find(r =>{ return r.dialogName == rpt.dialogName;})
      const modalRef = this.modalService.open(match.dialog, { centered: true, size: 'lg' });
      modalRef.componentInstance.report = rpt;
      modalRef.componentInstance.partyOn.subscribe((rsp : any[]) =>{
        rpt.params = rsp;
        // rsp.forEach(el =>{
        //   rpt.params.push(el);
        // }) ;//JSON.stringify(rsp);
        this.goGitIt(rpt);
      })
    }
    else{
      this.goGitIt(rpt);
    }   
  }

  goGitIt(rpt : ProcessorReport): void {
    this.rpts.getReportData(rpt).pipe(
      tap((res: Blob)=>{
        this.download(res,rpt);
      },(err: any)=>{
        console.log(err);
        this.toast.error('There was an error downloading the report. Please contact support.');
      })
    ).subscribe();
  }

  download(res: Blob, rpt : ProcessorReport): void {
    var date = new Date();

    this.fileDownload.HandleFileDownload(res, 'text/csv', `${date.toLocaleDateString()}-${rpt.reportDownloadName}`);
    this.toast.success('Report downloaded!');  
  }

}
